let traceSequence = 0;

function getPerformance(performanceApi) {
  if (performanceApi) return performanceApi;
  if (typeof performance !== 'undefined') return performance;
  return null;
}

export function createDocumentLoadTrace(documentType, performanceApi) {
  const perf = getPerformance(performanceApi);
  const traceName = `document-load:${documentType}:${++traceSequence}`;
  const startMark = `${traceName}:start`;

  if (perf && typeof perf.mark === 'function') perf.mark(startMark);

  return {
    name: traceName,
    mark(stage, fromStage) {
      if (!perf || typeof perf.mark !== 'function') return;
      const stageMark = `${traceName}:${stage}`;
      perf.mark(stageMark);
      if (typeof perf.measure === 'function') {
        perf.measure(`${traceName}:time-to-${stage}`, startMark, stageMark);
        if (fromStage) {
          perf.measure(
            `${traceName}:${fromStage}-to-${stage}`,
            `${traceName}:${fromStage}`,
            stageMark
          );
        }
      }
    }
  };
}

export function isAutomaticPrintRequest(query = {}) {
  return query.print === true || query.print === 'true' ||
    query.download === true || query.download === 'true';
}

export async function loadSavedDocumentPhase({ loadRequired, loadDocument }) {
  let requiredPromise;
  const documentPromise = Promise.resolve().then(() => loadDocument(requiredPromise));
  requiredPromise = Promise.resolve().then(loadRequired);
  const results = await Promise.all([requiredPromise, documentPromise].map(promise =>
    promise.then(
      value => ({ status: 'fulfilled', value }),
      reason => ({ status: 'rejected', reason })
    )
  ));
  const rejected = results.find(result => result.status === 'rejected');
  if (rejected) throw rejected.reason;
  return results[1].value;
}

export async function runDeferredDocumentTasks(tasks, onError) {
  const wrappedTasks = tasks.map(({ name, run }) =>
    Promise.resolve()
      .then(run)
      .then(value => ({ name, status: 'fulfilled', value }))
      .catch(error => {
        if (onError) onError(error, name);
        return { name, status: 'rejected', reason: error };
      })
  );

  return Promise.all(wrappedTasks);
}

export async function runRequiredDocumentTasks(tasks) {
  return Promise.all(tasks.map(async ({ name, run }) => {
    try {
      return { name, value: await run() };
    } catch (error) {
      if (error && (typeof error === 'object' || typeof error === 'function')) {
        error.documentTask = name;
        throw error;
      }
      const taskError = new Error(String(error));
      taskError.documentTask = name;
      throw taskError;
    }
  }));
}

export async function runExpressProductMutation({ preserveForm = false, mutate }) {
  if (preserveForm) return false;
  await mutate();
  return true;
}

export function createLatestRequestGuard() {
  let generation = 0;

  return {
    begin() {
      generation += 1;
      return generation;
    },
    isCurrent(requestGeneration) {
      return requestGeneration === generation;
    },
    invalidate() {
      generation += 1;
    }
  };
}
